(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CovidIndividualSearch', CovidIndividualSearch);

    CovidIndividualSearch.$inject = ['$resource'];

    function CovidIndividualSearch($resource) {
        var resourceUrl =  'api/_search/covid-individuals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
